<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
      <template #layoutContent>
        <div class="card shadow-sm">
            <div class="card-header">
                <div class="d-flex align-items-center">
                    <h1>{{$t('mail.save_imap_identify')}}</h1>
                </div>
            </div>
            <form @submit.prevent="submitForm" class="form">
                <div class="card-body p-9">
                    <RequiredText />
                    <Input
                        container-class="form-group mb-5"
                        :name="`imap-fullname`"
                        type="text"
                        :label="$t('mail.fullname')"
                        :placeholder="$t('mail.fullname')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        size="lg"
                        v-model="formData.fullname"
                    />
                    <Input
                        container-class="form-group mb-5"
                        :name="`imap-username`"
                        type="email"
                        :label="$t('mail.email')"
                        :placeholder="$t('mail.email')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        size="lg"
                        v-model="formData.username"
                    />
                    <Input
                        container-class="form-group"
                        :name="`imap-password`"
                        type="password"
                        :label="$t('mail.password')"
                        labelClass="form-label fs-6 text-black"
                        :placeholder="$t('mail.password')"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        size="lg"
                        v-model="formData.password"
                    />
                </div>
                <div class="card-footer d-flex justify-content-end py-6 px-9">
                    <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="isLoading"/>
                </div>
            </form>
          </div>
      </template>
    </SubLayout>
</template>

<script setup>
    import {computed, ref, watch, reactive, onMounted} from "vue";
    import SubLayout from "@/views/Layouts/partials/SubLayout.vue";                                                                                                                                                                                                                                                                                                          
    import RequiredText from "@/components/RequiredText"
    import Button from "@/components/Button.vue";
    import Input from "@/components/Input.vue";
    import {useStore} from "vuex";

    const store = useStore()
    const title = ref("breadcrumbs.mail.title")
    const breadcrumbs = ref([
        {
            name: 'mail.save_imap_identify',
            route: 'config-imap'
        }
    ])

    const isLoading = ref(false)
    const formData = ref({
        username: '',
        fullname: '',
        password: ''
    })

    const currentUser = computed(() => store.getters['user/currentUser'])
    const imapConfig = computed(() => store.getters['mails/getImapConfig'])

    watch(() => [imapConfig.value, currentUser.value], (value) => {
      if(value) {
        formData.value.username = imapConfig.value.email || currentUser.value?.email
        formData.value.fullname = imapConfig.value.fullname || currentUser.value?.fullname
      }
    }, { deep: true, immediate: true });

    async function submitForm(){
        try {
            isLoading.value = true;

            await store.dispatch('mails/setUserConfig', formData.value).then((res) =>{
                formData.value.password = ''
                window.toastr['success'](i18n.global.t('mail.config_successfully'))
            }) 
        } catch (error) {
        } finally {
            isLoading.value = false;
        }
    }

    onMounted(async() => {
        await store.dispatch('mails/getUserConfig')
    })
</script> 